import FormText from 'components/form/FormText';
import IndicatorButton from 'components/indicator/IndicatorButton';
import { AppConst } from 'constants/appConst';
import { AppHelper } from 'helpers/appHelper';
import { useAppState } from 'hooks/useAppState';
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

/**
 *　ログイン画面
 */
export default function Signin(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type FormStateType = {
    mailAddress: string;
  };

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();

  const [acctState] = useRecoilState(AcctState);

  const { signInRequest } = useAppState();

  const [processing, setProcessing] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<FormStateType>();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    // ログイン済の場合は、カンパニー選択画面に遷移
    if (acctState.user) {
      navigate('/signin/company');
    }
  }, []);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　ログインボタン押下時の処理
   */
  const onSignIn = () =>
    AppHelper.submit(
      processing,
      setProcessing,
      handleSubmit(async (data: FormStateType) => {
        try {
          // サインインリクエストを送信
          if (!(await signInRequest(data.mailAddress))) {
            setError('mailAddress', {
              type: 'custom',
              message: 'ご入力のメールアドレスのアカウントはありません。',
            });
            return;
          }
          // ログイン認証コード入力画面に遷移
          navigate('/signin/auth', {
            state: {
              mailAddress: data.mailAddress,
              nextTo: '/signin/company',
            },
          });
        } catch (e) {
          showBoundary(e);
        }
      })
    );

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-login">
        <div className="container">
          <div className="card card-login">
            <div className="card-body">
              <img
                src="img/common/logo.svg"
                alt="BranQ ブランク"
                className="d-block mx-auto card-logo"
              />
              <h1 className="card-title">ログイン</h1>
              <p className="lead">メールアドレスを入力してください</p>

              <form className="form-login">
                <div>
                  <FormText
                    subject="メールアドレス"
                    name="mailAddress"
                    placeholder="esteban_schiller@gmail.com"
                    register={register}
                    errors={errors}
                    required={true}
                    maxLength={300}
                    format="email"
                  />
                </div>
                <div className="form-footer">
                  <button
                    type="button"
                    className="btn btn-submit w-100"
                    onClick={onSignIn}
                    disabled={processing}
                  >
                    <IndicatorButton visible={processing} />
                    ログイン
                  </button>
                  <p className="account mb-0">
                    アカウントをお持ちでない場合
                    <br className="d-md-none" />
                    <a href={AppConst.url.support}>お問い合わせ</a>
                  </p>
                </div>
              </form>
            </div>
          </div>
          <div className="text-center">
            <a href={AppConst.url.privacy} target="_blank" className="caption">
              privacy &amp; Terms
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
